var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 40,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6389 15.0595C27.6389 16.9539 26.9642 18.6957 25.8349 20.0716C24.3517 22.1306 22.8636 24.9245 22.6993 26.2389H19.3195H15.9397C15.7754 24.9246 14.2874 22.1308 12.8042 20.0718C11.6748 18.6959 11 16.954 11 15.0595C11 10.6084 14.7248 7 19.3195 7C23.9142 7 27.6389 10.6084 27.6389 15.0595ZM15.6797 28.2788C15.6797 27.7266 16.1274 27.2788 16.6797 27.2788H21.9593C22.5115 27.2788 22.9593 27.7266 22.9593 28.2788V29.3986C22.9593 29.9509 22.5115 30.3986 21.9593 30.3986H21.8306C21.888 30.5613 21.9193 30.7363 21.9193 30.9186C21.9193 31.7801 21.2209 32.4785 20.3594 32.4785H18.2795C17.418 32.4785 16.7196 31.7801 16.7196 30.9186C16.7196 30.7363 16.7509 30.5613 16.8084 30.3986H16.6797C16.1274 30.3986 15.6797 29.9509 15.6797 29.3986V28.2788Z",
    fill: "#0F0A22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7732 15.3198C13.9413 13.471 15.2858 9.77344 19.3195 9.77344",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.cc4d502b78274f38d443eaca164c39bb.svg";
export { ForwardRef as ReactComponent };